import { Component } from '@angular/core';

@Component({
    selector: 'app-easter-egg',
    templateUrl: './easter-egg.component.html',
    styleUrls: ['./easter-egg.component.scss'],
    // eslint-disable-next-line @angular-eslint/prefer-standalone
    standalone: false,
})
export class EasterEggComponent {
    public dots = '.';
    public message = '';
    private index = 0;
    private messages = [
        { m: 'Initiating loading', t: 5000 },
        { m: 'Connecting to database', t: 5000 },
        { m: 'Downloading database', t: 10000 },
        { m: 'Unpacking database', t: 5000 },
        { m: 'Parsing database', t: 5000 },
        { m: 'Warming up instance factory', t: 2000 },
        { m: 'Building instance model', t: 10000 },
        { m: 'Building graph', t: 10000 },
        { m: 'Parsing layout', t: 10000 },
        { m: 'Error occured! Out of Memory', t: 7000 },
        { m: 'Preparing restart', t: 5000 },
    ];
    public constructor() {
        this.nextMessage();

        setInterval(() => {
            if (this.dots.length > 2) {
                this.dots = '.';
            } else {
                this.dots += '.';
            }
        }, 1000 / 3);
    }

    private nextMessage() {
        const obj = this.messages[this.index];
        this.message = obj.m;
        this.index = (this.index + 1) % this.messages.length;
        setTimeout(() => this.nextMessage(), obj.t);
    }
}
